<div class="container-fluid bg-primary">
  <div class="d-flex justify-content-between align-items-center py-2">
    <div class="text-white cursor-pointer" (click)="navigateToOverview()">My <strong>Fare</strong>Finder</div>

    <div class="btn-group" dropdown placement="bottom right">
      <a
        href
        id="header-menu-btn"
        class="text-white d-flex align-items-center"
        dropdownToggle
        aria-controls="header-menu"
        (click)="(false)"
      >
        {{ 'ANVR' | translate }} {{ selectedAffiliateCode }}
        <i class="mdi mdi-menu mdi-24px ml-2"></i>
      </a>

      <ul id="header-menu" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="header-menu-btn">
        <ng-container *ngIf="hasAffiliates$ | async">
          <li role="menuitem">
            <button class="dropdown-item cursor-pointer" (click)="openModal(chooseAffiliateModal, 'modal-sm')">
              {{ 'ANVR' | translate }} {{ selectedAffiliateCode }} ({{ 'MENU.AFF_CHANGE' | translate }})
            </button>
          </li>

          <li class="divider dropdown-divider"></li>
        </ng-container>

        <li role="menuitem">
          <a (click)="navigateToFareFinderPage()" class="dropdown-item cursor-pointer">FareFinder</a>
        </li>

        <li class="divider dropdown-divider"></li>

        <app-header-languages></app-header-languages>

        <li class="divider dropdown-divider"></li>

        <li role="menuitem" (click)="logOut()">
          <a class="dropdown-item d-flex align-items-center" href (click)="(false)">
            <i class="mdi mdi-logout-variant mdi-24px mr-2"></i>
            {{ 'MENU.LOG_OUT' | translate }}
          </a>
        </li>

        <li class="divider dropdown-divider"></li>

        <li role="menuitem" (click)="openModal(supportInfoModal)">
          <a class="dropdown-item" href (click)="(false)">{{ 'MENU.SUPPORT_INFO' | translate }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #supportInfoModal>
  <app-support-info (close)="modalRef.hide()"></app-support-info>
</ng-template>

<ng-template #chooseAffiliateModal>
  <app-affiliate-selection-modal (hideModal)="modalRef.hide()"></app-affiliate-selection-modal>
</ng-template>
